module.exports = __webpack_public_path__ + "img/header-right-options.a34d74fd.jpg";